var lastTop = $(window).scrollTop() ,
   handleScroll = function(){
      var sTop = $(window).scrollTop();

      $("#main-nav").removeClass('toggled');

      if( sTop > 50 && lastTop > sTop ){
         $("#topbar").addClass('fixed');

      }else{
         $("#topbar").removeClass('fixed');
      }
      lastTop = sTop;
   },
   makeSlick = function(){
      $(".slider").slick({
         infinite: true,
         slidesToShow: 2,
         slidesToScroll: 1,
         mobileFirst: true,
         prevArrow: "<div class='slick-prev'></div>",
         nextArrow: "<div class='slick-next'></div>",
         responsive: [
            {
               breakpoint: 385,
               settings: {
                  // centerMode: true
               }
            },
            {
               breakpoint: 450,
               settings: {
                  centerMode: false
               }
            },
            {
               breakpoint: 640,
               settings: {
                  slidesToShow: 3
               }
            },
            {
               breakpoint: 800,
               settings: {
                  slidesToShow: 4
               }
            },
            {
               breakpoint: 1000,
               settings: {
                  slidesToShow: 5
               }
            },
            {
               breakpoint: 1200,
               settings: {
                  slidesToShow: 6
               }
            },
         ]
      });
   },
    makeAnimation = function(itemIndex){
       var item = $("#section-header h2 [data-text][data-counter="+itemIndex+"]");
       if( item.length ){
          var text = item.attr('data-text');
          if( item.attr('data-delay') ) setTimeout( function(){ showText( item, text, 0, 100, itemIndex); }, 1000 )
          else showText( item, text, 0, 100, itemIndex);
       }
    },
   showText = function (target, message, index, interval,itemIndex) {
      // if(index==0){ $(target).css("opacity", 0); $(target).animate({"opacity": 1}, 500) }
      if (index < message.length) {
         $(target).append(message[index++]);
         setTimeout(function () { showText(target, message, index, interval, itemIndex); }, interval);
      }else{
         makeAnimation(itemIndex+1);
      }
   }
 ;

$(window).scroll(handleScroll);
$(window).on("load", function(){
   if( window.location.hash && window.location.hash != "#" ){
      var href = window.location.hash.replace("/#", "").replace("#", "");
      if( $("[data-rel='"+href+"']").length > 0 ){
         $("html,body").animate({"scrollTop": $("[data-rel='"+href+"']").offset().top}, 1000 );
      }
   }

   var video = $("#header-video").attr('data-video');
   if( video ){
      $("#header-video").replaceWith('<video autoplay muted loop id="header-video">\n' +
          '            <source src="'+video+'" type="video/mp4">\n' +
          '        </video>')
   }

   setTimeout(function(){
      makeAnimation(0);
   },300)

   // if( $("#section-header h2 [data-text][data-counter=0]").length ){
   //    var item = $("#section-header h2 [data-text][data-counter=0]");
   // }
   // $("#section-header h2 [data-text]").each(function(){
   //    var item = $(this),
   //        interval = 600 * parseInt( $(this).attr('data-counter') ),
   //        text = item.attr('data-text');
   //    console.log(interval);
   //    if( text ) setTimeout(function () { showText( item, text, 0, 100); }, interval);
   // });
})

$(function(){
   handleScroll();
   makeSlick();

   $(document).on("click", "#nav-toggler", function(){
      $("#main-nav").toggleClass('toggled');
   });

   $(document).on("click", "a", function(){
      var href = $(this).attr('href').replace("/#", "").replace("#", "");

      if( $("[data-rel='"+href+"']").length > 0 ){
         $("html,body").animate({"scrollTop": $("[data-rel='"+href+"']").offset().top}, 1000 );
      }
   });

   $(document).on("click", ".team .team-item", function(){
      var img = $(this).attr('data-image'),
          name = $(this).find('.label').text(),
          description = $(this).attr('data-description')
      ;

      $("#popup img").attr('src', img).attr('alt', name);
      $("#popup h3").html(name);
      $("#popup p").html(description);

      $("#popup").fadeIn();
      $("html").addClass('popuped');
   });

   $(document).on("click", "#popup .close, #popup", function(event){
      event.stopPropagation();
      $("#popup").fadeOut(function(){
         $(this).find('img').attr('src', "").attr('alt', "");
         $(this).find("h3").text("");
         $(this).find("p").text("")
      });
      $("html").removeClass('popuped');
   });

   $(document).on("click", "#popup .popup-content", function(event){
      event.stopPropagation();
   });

});